import { defineStore } from 'pinia';

import { createdCampaigns } from '../resources/js/api/crowdpacs.js';

export const useCampaignStore = defineStore('campaign', {
  state: () => {
    return {
      isCampaignSection: false,
      userHasCreatedCampaigns: false,
    };
  },
  actions: {
    setIsCampaignSection(val) {
      this.isCampaignSection = val;
    },
    getCreatedCampaigns() {
      createdCampaigns()
        .then(res => {
          this.userHasCreatedCampaigns = res.crowdpacs_created;
        })
        .catch(error => {
          console.warn(error);
        });
    },
  },
});
